import dayjs from 'dayjs'
import { DAY_OF_WEEK } from 'components/phone-availibility/PhoneAvailability.constants'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { DATE_FORMAT_ISO } from 'features/registration/constants'

dayjs.extend(customParseFormat)

/**
 * Check if a given date is a weekend (Saturday or Sunday).
 * @param {dayjs.ConfigType} d
 * @returns {boolean}
 */
export const isWeekend = (d?: dayjs.ConfigType): boolean => {
  const date = d ? dayjs(d) : dayjs()
  return date.day() === DAY_OF_WEEK.saturday || date.day() === DAY_OF_WEEK.sunday
}

/**
 * Check if given date matches any of the desired display formats
 * @param {string} date
 * @returns {boolean}
 */
export const checkIsValidDisplayDateNotation = (date: string): boolean => {
  if (!date) return true

  return dayjs(date, ['DD/MM/YYYY', 'D/M/YYYY', 'DD/M/YYYY', 'D/MM/YYYY'], true).isValid()
}

/**
 * Convert DD/MM/YYYY to YYYY-MM-DD
 * @param {string} date
 * @returns {string}
 */
export const convertDisplayDateToISO = (date?: string): string | undefined => {
  if (date) {
    const isValidDate = checkIsValidDisplayDateNotation(date)

    return isValidDate ? dayjs(date, ['DD/MM/YYYY', 'D/M/YYYY', 'DD/M/YYYY', 'D/MM/YYYY'], true).format(DATE_FORMAT_ISO) : date
  }

  return date
}
